export default "__VITE_PUBLIC_ASSET__12bbccc3__"